<template>
<div class="slide slide05">
	<h3 class="title">통합 퍼포먼스 전략 하에서 미디어믹스에 따른 크리에이티브믹스를 완성합니다</h3>
	<span class="text">
		통합 퍼포먼스 전략 하에서  미디어믹스에 따른  크리에이티브믹스를 완성할 수 있는 조직적 인프라 구축, <br>
		종합광고대행사의 인프라를 구축하고 있는 GnM performance만의 차별화 요소입니다.
	</span>

	<div class="tableBox" v-if="$device.windows">
		<table class="table">
			<colgroup>
				<col width="20%">
				<col width="20%">
				<col width="20%">
				<col width="20%">
				<col width="20%">
			</colgroup>
			<thead>
				<th></th>
				<th>Performance Video</th>
				<th>Landing Page</th>
				<th>Display AD</th>
				<th>Performance Copy</th>
			</thead>
			<tbody>
				<tr class="first">
					<th>
						Performance <br> Creatives
					</th>
					<td>
						퍼포먼스 동영상 <br> 광고 제작을 위한 <br> 동영상 촬영, 편집, 2D, 3D
					</td>
					<td>
						소비자의 실제 액션을 유도하기 위한 <br> 랜딩 페이지 기획, 제작, UI분석, <br> 랜딩페이지 최적화
					</td>
					<td>
						소비자의 클릭을 유도하기 위한 <br> 크리에이티브 컨셉, 카피라이팅, <br> 디자인, 크리에이티브 최적화
					</td>
					<td>
						소비자의 클릭을 유도하기 위한 <br> 행동유발형 카피라이팅, 컨셉 기획 <br> T&amp;D 최적화, 소셜컨텐츠 라이팅
					</td>
				</tr>
				<tr class="two">
					<th>
						Creative Infra
					</th>
					<td>
						동영상 제작의 퀄리티, 속도, <br> 수량을 담보할 수 있는 내부 인력과 <br> 외부 인프라 구축

						<ul>
							<li>Performance CD 조직 세팅 완료</li>
							<li>내부 영상 제작팀 구축</li>
							<li>크리에이티브 부티크</li>
							<li>프로덕션 Pool 구축</li>
						</ul>
					</td>
					<td>
						소비자 액션 유도를 위한 랜딩페이지 <br> 크리에이티브 제작/개발, 유실 방지를 <br> 위한 UI 분석, 웹기획 조직 구축

						<ul>
							<li>웹기획자 중심</li>
							<li>웹기획팀 구축</li>
							<li>개발팀(6명) 구축</li>
							<li>크리에이티브 디자인 조직 완결</li>
							<li>UX/UI 전문조직 세팅</li>
						</ul>
					</td>
					<td>
						클릭 유도를 위한 퍼포먼스 디자인 <br> 조직, 크리에이티브 최적화를 위한 <br> 크리에이티브 템플릿 개발

						<ul>
							<li>Performance CD 조직 세팅 완료</li>
							<li>크리에이티브 디자인 조직 완결</li>
						</ul>
					</td>
					<td class="last">
						소비자 클릭 유도를 위한 <br> 행동유발형 카피와 소셜 컨텐츠 <br> 라이팅을 위한 카피 조직 세팅

						<ul>
							<li>Performance CD 조직 내 <br>Performance CW 세팅</li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div class="serviceImg" v-else>
		<img src="@/assets/images/featureSlideMo04.png" alt="">
	</div>
	<div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
	methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>